import React, { useState } from 'react';
import { OpenPopupButton } from './styles';
import Modal from 'components/utility/Modal/Modal';
import { EntityTypes } from 'context/entityContext';
import AddEntityToListView from './AddEntityToListView';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import { ReactComponent as IconAdd } from 'icons/icon-include.svg';

interface IAddToListButtonProps {
  entityId: string;
  entityName: string;
  entityType: EntityTypes;
}

const AddToListButton: React.FC<IAddToListButtonProps> = (props) => {
  const { entityId, entityName, entityType } = props;
  const [showModal, setShowModal] = useState(false);

  const apiEntityType = entityTypeToApiType(entityType) as EntityTypes;

  const canAddToList = entityType !== 'label';

  const openAddToListDialog = (): void => {
    setShowModal(true);
  };

  const hideModal = (): void => {
    setShowModal(false);
  };

  return (
    <>
      {canAddToList && (
        <OpenPopupButton
          onClick={openAddToListDialog}
          data-pw="custom-lists-add-to-list-btn"
        >
          <IconAdd />
          <span>{'Add to list'}</span>
        </OpenPopupButton>
      )}
      {showModal && (
        <Modal hide={hideModal} canClickOutside={true}>
          <AddEntityToListView
            close={hideModal}
            entityId={entityId}
            entityName={entityName}
            entityType={apiEntityType}
          />
        </Modal>
      )}
    </>
  );
};

export default AddToListButton;
